export default {
    topics: [
        {
            title: ' getAttribute ',
            href: 'm-DOMElement-getAttribute.html',
            attributes: { 'data-id': 'm-DOMElement-getAttribute' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getAttribute-d66e7274',
            topics: [],
        },
        {
            title: ' getAttributeNS ',
            href: 'm-DOMElement-getAttributeNS.html',
            attributes: { 'data-id': 'm-DOMElement-getAttributeNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getAttributeNS-d66e7282',
            topics: [],
        },
        {
            title: ' getBooleanValue ',
            href: 'm-DOMElement-getBooleanValue.html',
            attributes: { 'data-id': 'm-DOMElement-getBooleanValue' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getBooleanValue-d66e7290',
            topics: [],
        },
        {
            title: ' getDateValue ',
            href: 'm-DOMElement-getDateValue.html',
            attributes: { 'data-id': 'm-DOMElement-getDateValue' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getDateValue-d66e7298',
            topics: [],
        },
        {
            title: ' getElements ',
            href: 'm-DOMElement-getElements.html',
            attributes: { 'data-id': 'm-DOMElement-getElements' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getElements-d66e7306',
            topics: [],
        },
        {
            title: ' getElementsByTagName ',
            href: 'm-DOMElement-getElementsByTagName.html',
            attributes: { 'data-id': 'm-DOMElement-getElementsByTagName' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getElementsByTagName-d66e7314',
            topics: [],
        },
        {
            title: ' getElementsByTagNameNS ',
            href: 'm-DOMElement-getElementsByTagNameNS.html',
            attributes: { 'data-id': 'm-DOMElement-getElementsByTagNameNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getElementsByTagNameNS-d66e7322',
            topics: [],
        },
        {
            title: ' getFirstElement ',
            href: 'm-DOMElement-getFirstElement.html',
            attributes: { 'data-id': 'm-DOMElement-getFirstElement' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getFirstElement-d66e7330',
            topics: [],
        },
        {
            title: ' getNumberValue ',
            href: 'm-DOMElement-getNumberValue.html',
            attributes: { 'data-id': 'm-DOMElement-getNumberValue' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getNumberValue-d66e7338',
            topics: [],
        },
        {
            title: ' getValue ',
            href: 'm-DOMElement-getValue.html',
            attributes: { 'data-id': 'm-DOMElement-getValue' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-getValue-d66e7346',
            topics: [],
        },
        {
            title: ' hasAttribute ',
            href: 'm-DOMElement-hasAttribute.html',
            attributes: { 'data-id': 'm-DOMElement-hasAttribute' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-hasAttribute-d66e7355',
            topics: [],
        },
        {
            title: ' hasAttributeNS ',
            href: 'm-DOMElement-hasAttributeNS.html',
            attributes: { 'data-id': 'm-DOMElement-hasAttributeNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-hasAttributeNS-d66e7363',
            topics: [],
        },
        {
            title: ' hasElement ',
            href: 'm-DOMElement-hasElement.html',
            attributes: { 'data-id': 'm-DOMElement-hasElement' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-hasElement-d66e7371',
            topics: [],
        },
        {
            title: ' removeAttribute ',
            href: 'm-DOMElement-removeAttribute.html',
            attributes: { 'data-id': 'm-DOMElement-removeAttribute' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-removeAttribute-d66e7379',
            topics: [],
        },
        {
            title: ' removeAttributeNS ',
            href: 'm-DOMElement-removeAttributeNS.html',
            attributes: { 'data-id': 'm-DOMElement-removeAttributeNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-removeAttributeNS-d66e7387',
            topics: [],
        },
        {
            title: ' setAttribute ',
            href: 'm-DOMElement-setAttribute.html',
            attributes: { 'data-id': 'm-DOMElement-setAttribute' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-setAttribute-d66e7395',
            topics: [],
        },
        {
            title: ' setAttributeNS ',
            href: 'm-DOMElement-setAttributeNS.html',
            attributes: { 'data-id': 'm-DOMElement-setAttributeNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-setAttributeNS-d66e7403',
            topics: [],
        },
        {
            title: ' setIdAttribute ',
            href: 'm-DOMElement-setIdAttribute.html',
            attributes: { 'data-id': 'm-DOMElement-setIdAttribute' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-setIdAttribute-d66e7411',
            topics: [],
        },
        {
            title: ' setIdAttributeNS ',
            href: 'm-DOMElement-setIdAttributeNS.html',
            attributes: { 'data-id': 'm-DOMElement-setIdAttributeNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-setIdAttributeNS-d66e7419',
            topics: [],
        },
        {
            title: ' tagName ',
            href: 'p-DOMElement-tagName.html',
            attributes: { 'data-id': 'p-DOMElement-tagName' },
            menu: { hasChildren: false },
            tocID: 'p-DOMElement-tagName-d66e7427',
            topics: [],
        },
        {
            title: ' toXMLString ',
            href: 'm-DOMElement-toXMLString.html',
            attributes: { 'data-id': 'm-DOMElement-toXMLString' },
            menu: { hasChildren: false },
            tocID: 'm-DOMElement-toXMLString-d66e7435',
            topics: [],
        },
    ],
};

